import { createContext } from 'use-context-selector'
import { ContextByPLMType, initialStateByPLM } from './PLM.types'

export const ContextByPLM = createContext<ContextByPLMType>([
  initialStateByPLM,
  state => state,
])

export const ProviderPLM = ContextByPLM.Provider
